<template>
    <router-view></router-view>
</template>
<script>
    export default {
        data() {
            return {}
        },
        components: {},
        methods: {}
    }
</script>
<style scoped lang="stylus">

</style>



// WEBPACK FOOTER //
// src/App.vue